var _linearGradient, _path, _path2, _linearGradient2, _path3, _linearGradient3, _path4, _linearGradient4, _path5, _linearGradient5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_357a54654edf433869d9b81dfc5591f9200fd135b1142aaf1c16aac48d3e3847",
    gradientUnits: "userSpaceOnUse",
    x1: -7747.177,
    y1: -1052.43,
    x2: -7746.177,
    y2: -1052.43
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M33.328 35.411l9.053 6.21 8.959-6.21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M67.736 19.204v36.512H17.073V19.204"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_357a54654edf433869d9b81dfc5591f9200fd135b1142aaf1c16aac48d3e3847",
    gradientUnits: "userSpaceOnUse",
    x1: 12.479,
    y1: 16.515,
    x2: 72.521,
    y2: 16.515
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_357a54654edf433869d9b81dfc5591f9200fd135b1142aaf1c16aac48d3e3847)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M13.104 14.141h58.793v4.749H13.104z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_357a54654edf433869d9b81dfc5591f9200fd135b1142aaf1c16aac48d3e3847",
    gradientUnits: "userSpaceOnUse",
    x1: 12.607,
    y1: 11.296,
    x2: 72.456,
    y2: 11.296
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_2_357a54654edf433869d9b81dfc5591f9200fd135b1142aaf1c16aac48d3e3847)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M13.232 14.008l5.157-5.425h47.905l5.537 5.425"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_357a54654edf433869d9b81dfc5591f9200fd135b1142aaf1c16aac48d3e3847",
    gradientUnits: "userSpaceOnUse",
    x1: 32.703,
    y1: 41.396,
    x2: 51.965,
    y2: 41.396
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_3_357a54654edf433869d9b81dfc5591f9200fd135b1142aaf1c16aac48d3e3847)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M33.328 35.411h18.011v11.97H33.328z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_357a54654edf433869d9b81dfc5591f9200fd135b1142aaf1c16aac48d3e3847",
    gradientUnits: "userSpaceOnUse",
    x1: 22.9,
    y1: 27.592,
    x2: 61.528,
    y2: 27.592
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_4_357a54654edf433869d9b81dfc5591f9200fd135b1142aaf1c16aac48d3e3847)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M23.525 27.592h37.378"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/inbox.e294108522d73b74bd900dad62c3cea8.svg";
export { ForwardRef as ReactComponent };